<template>
  <div>
    <el-form :model='invoiceData' label-width='120px' :rules='invoiceRules' ref='invoiceForm'
             size='medium'>
      <div-border label='开票信息' divStyle='margin-top: 10px;padding-top:15px;'>
        <el-row>
          <el-col :span='24'>
            <el-form-item label='服务名称：' prop='serviceName' label-width='150px'>
              <el-select v-model='invoiceData.serviceName' placeholder='请选择'>
                <el-option
                  v-for='(item, index) in serviceNameOptions'
                  :key='index'
                  :label='item.classaName'
                  :value='item.classaName' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='结算数量：' prop='settlementNum' label-width='150px'>
              <el-input v-model='invoiceData.settlementNum' type='number'
                        @change='calculateTaxPrice' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='其他结算数量：' prop='otherNum' label-width='150px'>
              <el-input v-model='invoiceData.otherNum' type='number' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='对账调整数量：' prop='adjustNum' label-width='150px'>
              <el-input v-model='invoiceData.adjustNum' type='number' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='含税金额：' prop='taxPrice' label-width='150px'>
              <el-input v-model='invoiceData.taxPrice' type='number' @change='calculateUnitPrice' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='单价：' prop='unitPrice' label-width='150px'>
              <el-input v-model='invoiceData.unitPrice' type='number' @change='calculateTaxPrice' />
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label='规格型号：' prop='specificaModel' label-width='150px'>
              <el-input
                v-model='invoiceData.specificaModel'
                type='textarea'
                autosize />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='数量：' prop='number' label-width='150px'>
              <el-input
                v-model.number='invoiceData.numberStr'
                type='textarea'
                autosize />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label='单位：' prop='unit' label-width='150px'>
              <el-select
                v-model='invoiceData.unit' placeholder="请选择">
                <el-option
                  v-for='(item, index) in unitNameOptions'
                  :key='index'
                  :label='item.classaName'
                  :value='item.classaName' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label='备注：' prop='remark' label-width='150px'>
              <el-input
                v-model='invoiceData.remark'
                type='textarea'
                autosize />
            </el-form-item>
          </el-col>
          <el-col :span='invoiceData.isDeduct ? 12 : 24'>
            <el-form-item label='是否抵扣开票：' prop='isDeduct' label-width='150px'>
              <el-radio v-model='invoiceData.isDeduct' :label='0'>否</el-radio>
              <el-radio v-model='invoiceData.isDeduct' :label='1'>是</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item
              v-if='invoiceData.isDeduct'
              prop='deductId'
              label='选择抵扣开票：'
              label-width='150px'>
              <el-select v-model='invoiceData.deductId' placeholder='请选择选择抵扣开票'
                         collapse-tags @change="selectDeductId">
                <el-option
                  v-for='item in deductIdOptions'
                  :key='item.id'
                  :label='item.deductionNum'
                  :value='item.id' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item
              v-if='deductMoneyShow' prop='deductMoney' label='抵扣开票金额：' label-width='150px'>
              <el-input v-model="invoiceData.deductMoney" size="mini" style="width:100%" placeholder="请输入抵扣开票金额"/>
            </el-form-item>
          </el-col>
          <el-col :span='invoiceData.isDeductionPrice ? 12 : 24'>
            <el-form-item label='超合同金额：' prop='isDeductionPrice' label-width='150px'>
              <el-radio v-model='invoiceData.isDeductionPrice' :label='0'>否</el-radio>
              <el-radio v-model='invoiceData.isDeductionPrice' :label='1'>是</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item
              v-if='invoiceData.isDeductionPrice'
              prop='deductionPriceId'
              label='选择超合同金额：'
              label-width='150px'>
              <el-select v-model='invoiceData.deductionPriceId' placeholder='请选择' multiple
                         collapse-tags>
                <el-option
                  v-for='item in deductionPriceId'
                  :key='item.id'
                  :label='item.taxPriceDifference'
                  :value='item.id' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='invoiceData.isSuspendBilling ? 12 : 24'>
            <el-form-item label='是否暂缓开票：' prop='isSuspendBilling' label-width='150px'>
              <el-radio v-model='invoiceData.isSuspendBilling' :label='0'>否</el-radio>
              <el-radio v-model='invoiceData.isSuspendBilling' :label='1'>是</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item
              v-if='invoiceData.isSuspendBilling'
              prop='suspendBillingPrice'
              label='暂缓开票金额：'
              label-width='150px'>
              <el-input v-model='invoiceData.suspendBillingPrice'>
                <template slot='append'>
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span='invoiceData.isUseSusBill ? 12 : 24'>
            <el-form-item label='是否使用暂缓开票：' prop='isUseSusBill' label-width='150px'>
              <el-radio v-model='invoiceData.isUseSusBill' :label='0'>否</el-radio>
              <el-radio v-model='invoiceData.isUseSusBill' :label='1'>是</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item
              v-if='invoiceData.isUseSusBill'
              prop='suspendBillId'
              label='暂缓开票：'
              label-width='150px'>
              <el-select v-model='invoiceData.suspendBillId' placeholder='请选择' multiple
                         collapse-tags>
                <el-option
                  v-for='item in suspendBillIdOptions'
                  :key='item.id'
                  :label='item.susBillPrice'
                  :value='item.id' />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div class='btnContainer'>
        <el-button size='medium' class='searchBtn' @click='auditConfirmClick'>确定</el-button>
        <el-button size='medium' class='resetBtn' @click='auditClose("cancel")'>关闭</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import {
    addInvoice,
    getDeductIdOptions, getDeductionPriceId,
    getSelectData,
    getServiceName, selectCategoryAttr,
    updateInvoice,
  } from '@/service/getData';
  import {getPortName} from "@/service/vehiclelog";

  export default {
    name: 'addInvoice',
    components: {
      divBorder,
    },
    data() {
      return {
        // 表头样式
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        // 单元格样式
        cellStyle: {
          color: '#7F7F7F',
          'font-size': '13px',
          height: '52px',
        },
        // 结算数量
        settlementNum: 0,
        // 其他数量
        otherNum: 0,
        // 发票数据
        invoiceData: {
          adjustNum: 0,
          basicId: '',
          serviceName: '',
          settlementNum: 0,
          otherNum: 0,
          taxPrice: 0,
          unitPrice: 0,
          specificaModel: '',
          number: 0,
          unit:'',
          remark: '',
          isDeduct: 0,
          deductId: '',
          deductMoney: '',
          isDeductionPrice: 0,
          deductionPriceId: '',
          isSuspendBilling: 0,
          suspendBillingPrice: '',
          isUseSusBill: 0,
          suspendBillId: '',
        },
        deductMoneyShow: false,
        // 发票校验规则
        invoiceRules: {
          serviceName: [
            {
              required: true,
              message: '请选择服务名称',
              trigger: 'blur',
            },
          ],
          settlementNum: [
            {
              required: true,
              message: '请输入结算数量',
              trigger: 'blur',
            },
          ],
          adjustNum: [
          {
              required: true,
              message: '请输入对账调整数量',
              trigger: 'blur',
            },
          ],
          otherNum: [
            {
              required: true,
              message: '请输入其他结算数量',
              trigger: 'blur',
            },
          ],
          taxPrice: [
            {
              required: true,
              message: '请输入含税金额',
              trigger: 'blur',
            },
          ],
          unitPrice: [
            {
              required: true,
              message: '请输入单价',
              trigger: 'blur',
            },
          ],
          specificaModel: [
            {
              required: true,
              message: '请输入规格型号',
              trigger: 'blur',
            },
          ],
          // number:  [
          //   {
          //     required: true,
          //     message: '请输入数量',
          //     trigger: 'blur',
          //   },
          // ],
          // unit:  [
          //   {
          //     required: true,
          //     message: '请选择单位',
          //     trigger: 'blur',
          //   },
          // ],
          remark: [
            {
              required: true,
              message: '请输入备注',
              trigger: 'blur',
            },
          ],
          isDeduct: [
            {
              required: true,
              message: '请选择是否抵扣开票',
              trigger: 'blur',
            },
          ],
          deductId: [
            {
              required: true,
              message: '请选择选择抵扣开票',
              trigger: 'blur',
            },
          ],
          deductMoney: [
            {
              required: true,
              message: '请输入抵扣开票金额',
              trigger: 'blur',
            },
          ],
          isDeductionPrice: [
            {
              required: true,
              message: '请选择超合同金额',
              trigger: 'blur',
            },
          ],
          deductionPriceId: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          isSuspendBilling: [
            {
              required: true,
              message: '请选择是否暂缓开票',
              trigger: 'blur',
            },
          ],
          suspendBillingPrice: [
            {
              required: true,
              message: '请输入暂缓开票金额',
              trigger: 'blur',
            },
          ],
          isUseSusBill: [
            {
              required: true,
              message: '请选择是否使用暂缓开票',
              trigger: 'blur',
            },
          ],
          suspendBillId: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
        },
        // 服务名称数据
        serviceNameOptions: [],
        //单位数据
        unitNameOptions: [],
        // 抵扣开票数据
        deductIdOptions: [],
        // 超合同金额数据
        deductionPriceId: [],
        // 暂缓开票数据
        suspendBillIdOptions: [],
        addOrEdit: 'add',
      };
    },
    methods: {
      calculateUnitPrice() {
        this.invoiceData.unitPrice = this.invoiceData.taxPrice / this.invoiceData.settlementNum;
        this.$forceUpdate();
      },
      calculateTaxPrice() {
        this.invoiceData.taxPrice = this.invoiceData.unitPrice * this.invoiceData.settlementNum;
        this.$forceUpdate();
      },
      async getSelection(companyId) {
        this.suspendBillIdOptions = await getSelectData({ companyId });
        this.deductIdOptions = await getDeductIdOptions({ companyId });
        this.deductionPriceId = await getDeductionPriceId({ companyId });
      },
      selectDeductId(){
        if(this.invoiceData.deductId == null || this.invoiceData.deductId == ''){
          this.deductMoneyShow = false
        }else {
          this.deductMoneyShow = true
        }
      },
      async getServiceName() {
        const {
          data,
          message,
          status,
        } = await getServiceName();
        if (status !== 0) return this.$message.warning(message);
        this.serviceNameOptions = data;
      },
      async _selectCategoryAttr(){
        const {
          data,
          message,
          status,
        } = await selectCategoryAttr();
        if (status !== 0) return this.$message.warning(message);
        this.unitNameOptions = data;
      },
      auditConfirmClick() {
        console.log(this.invoiceData.settlementNum, this.settlementNum);
        if (this.invoiceData.settlementNum > this.settlementNum) return this.$message.warning('结算数量不能超过剩余结算数量！');
        if (this.invoiceData.otherNum > this.otherNum) return this.$message.warning('其他结算数量不能超过剩余其他结算数量！');
        let invoiceData = JSON.parse(JSON.stringify(this.invoiceData));
        invoiceData.deductionPriceId = this.formatStr(this.invoiceData.deductionPriceId);
        invoiceData.suspendBillId = this.formatStr(this.invoiceData.suspendBillId);
        this.$refs.invoiceForm.validate(async (valid) => {
          if (valid) {
            let data;
            if (this.addOrEdit === 'add') {
              data = await addInvoice(invoiceData);
            } else {
              data = await updateInvoice(invoiceData);
            }
            if (data.status === 0) {
              this.$message.success(data.message);
              this.auditClose('confirm');
            } else {
              this.$message.warning(data.message);
            }
          }
        });
      },
      formatStr(val) {
        let str = '';
        if (val instanceof Array && val) {
          val.forEach(res => {
            str += res + ',';
          });
        }
        return str.substring(0, str.length - 1);
      },
      auditClose(val) {
        this.reset();
        this.$emit('addInvoiceClose', val);
      },
      reset() {
        this.invoiceData = {
          basicId: '',
          serviceName: '',
          settlementNum: 0,
          otherNum: 0,
          taxPrice: 0,
          unitPrice: 0,
          specificaModel: '',
          number: 0,
          unit:'',
          remark: '',
          isDeduct: 0,
          deductId: '',
          deductMoney: '',
          isDeductionPrice: 0,
          deductionPriceId: '',
          isSuspendBilling: 0,
          suspendBillingPrice: '',
          isUseSusBill: 0,
          suspendBillId: '',
        };
      },
    },
  };
</script>

<style lang='scss' scoped>
  .el-select {
    width: 100%;
  }

  .btnContainer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 10px 0;

    button {
      margin: 0 15px;
    }
  }
</style>
